module.exports = __webpack_public_path__ + "img/tra_bg_hon@2x.5f9e4ce6.png";